// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import { Action } from "redux"
import type { RootState } from "../../../app/store"
import searchRecentManualTimeComments from "./searchRecentManualTimeComments"
import addManualTime from "./addManualTime"
import loadActivity from "./loadActivity"
import persistActivity from "./persistActivity"

export default combineEpics<Action, Action, RootState, unknown>(
  searchRecentManualTimeComments,
  addManualTime,
  
  loadActivity,
  persistActivity,
)
